export enum SidepanelRouteType {
  RMM = 'rmm',
  Backup = 'backup',
  RD = 'rd',
  ClientSettings = 'client-settings',
  ConnectSettings = 'connect-settings',
  BackupHistory = 'backup-history'
}

export enum SidepanelId {
  RMM = 'computer_rmm_info',
  Backup = 'computer_backup_info',
  RD = 'rd',
  ClientSettings = 'client_settings',
  ConnectSettings = 'connect-computer-settings',
  Tags = 'sidepanel-tags',
  BackupHistory = 'backup-history',
  IPWhiteList = 'ip-white-list-panel'
}
